import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscriptions', 'Lifetime Access', '7-Day Money-Back Guarantee'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-91" data-mp="9lbeyxpzr5c0">
      <div className="mx-auto max-w-4xl text-center" data-id="element-92" data-mp="4m8lmajdinjv">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-93" data-mp="4jm5hmif2zq1">
          Plan a Full Year of Dance Classes in Just{' '}
          <span className="italic text-brand" data-id="element-94" data-mp="nb6njukxbpp7">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-95" data-mp="3d1sc51sntrv8">
          Join over 1,500 dance teachers who have stopped improvising. Walk into
          your studio with everything ready to teach, inspire, and lead.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-96" data-mp="39cpc2rohrf1b">
          <img src="https://cdn.magicpatterns.com/uploads/kMYRvnd8CRVfdkbEsMAGBo/cd89b9d8-8d99-4f8a-8102-5b331ca8fda1.webp" alt="The DANCE READY bundle: six volumes from Preschool to Professional Excellence, the digital lesson platform on desktop, tablet and phone, and the 5 included bonuses" className="mx-auto w-[86%] max-w-xl sm:w-[80%]" data-id="element-97" data-mp="35aausc0h0nc5" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-2xl text-sm leading-relaxed text-ink/55 sm:text-base" data-id="element-98" data-mp="2ljz1alsbr1sm">
          <span className="font-bold text-ink" data-id="element-99" data-mp="id050tel8app">The DANCE READY™ Bundle:</span>{' '}
          the 6 volumes covering all levels from Preschool to Professional + the
          Choreography &amp; Performance Kit + the Teacher&apos;s
          Quick-Reference Handbook + 5 Strategic Bonuses included.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-6" data-id="element-100" data-mp="162m0b5rua5sf">
          <CtaButton href="#offer" data-id="element-101" data-mp="x3h1rzga2cg9" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-102" data-mp="3lt75ys5mbtus">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-103" data-mp="1x9krqeihcqdi" data-mpi={index}>
                <span data-id="element-104" data-mp="1x7869rdijxvp">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-105" data-mp="21b631vfd8wll">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}